import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/ComparisonIndex.tsx");
